import {useEffect} from "react";

import {scrollToTop} from "./useScrollToTopOnHistoryChange";

export const useScrollTopEffect = (selector: string, scrollTriggers: any[]) =>
  useEffect(() => {
    requestAnimationFrame(() => scrollToTop(selector));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selector, ...scrollTriggers]);
